import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeleteSnoozePayload } from "components";

export const useDeleteQuestionResultSnoozeMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeleteSnoozePayload) => {
      await ApiInstance.post("/snoozes/delete", payload);
    },
    onSuccess: ({ question_result_id }) => {
      const checks = typedQueryClient.getQueryData(AppointmentDetailsKeys.checks);
      if (!checks) return;

      const checkIdx = checks.findIndex(check => check.question_items?.some(item => item.id === question_result_id));
      if (checkIdx === -1 || !checks[checkIdx].question_items?.length) return;

      const questionResults = checks[checkIdx].question_items;
      const questionResultIdx = questionResults.findIndex(qi => qi.id === question_result_id);
      if (questionResultIdx === -1 || !questionResults[questionResultIdx].snooze_history?.length) return;

      typedQueryClient.setQueryData(
        AppointmentDetailsKeys.checks,
        checks.with(checkIdx, {
          ...checks[checkIdx],
          question_items: questionResults.with(questionResultIdx, { ...questionResults[questionResultIdx], snoozed: false, snooze_history: [] })
        })
      );
    }
  });
